import React from "react";

// Tiny persisted-settings store: localStorage + a window event so every
// consumer of a setting re-renders when any window (Settings panel,
// tray volume, etc.) changes it. Values are JSON-encoded.

const EVENT = "saat:setting";

export function readSetting(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writeSetting(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage full/blocked: the in-session event still works.
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { key, value } }));
}

export default function useSetting(key, fallback) {
  const [value, setValue] = React.useState(() => readSetting(key, fallback));
  React.useEffect(() => {
    const onChange = (e) => {
      if (e.detail?.key === key) setValue(e.detail.value);
    };
    window.addEventListener(EVENT, onChange);
    return () => window.removeEventListener(EVENT, onChange);
  }, [key]);
  const set = React.useCallback((v) => writeSetting(key, v), [key]);
  return [value, set];
}
